import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BikeRentalDetailPage.css"; // reuse same CSS

const BicycleRentalDetailPage = () => {
  const [bookingType, setBookingType] = useState("self");
  const [showPolicy, setShowPolicy] = useState(false);
  const [dropDateTime, setDropDateTime] = useState("");
  const [paymentType, setPaymentType] = useState("full");
         const [showAllFeatures, setShowAllFeatures] = useState(false);
const basicBicycleFeatures = [
  "Adjustable Seat",
  "Lightweight Frame",
  "Front & Rear Brakes",
  "Comfort Handle Grip",
  ];
  const extraBicycleFeatures = [
    "Multi-Speed Gears",
    "Water Bottle Holder",
    "Rear Carrier",
    "Bell / Horn",
    "Reflectors for Night Safety",
    "Suspension Fork",
    "Quick Release Wheels",
    "Mudguards",
  ];
  const location = useLocation();
  const navigate = useNavigate();

  let data = location.state;

  const [userDetails, setUserDetails] = useState({
    name: "",
    phone: "",
    email: "",
    passengerName: "",
    passengerPhone: "",
    agreed: true,
  });

  const [files, setFiles] = useState({
    userId: null,
    passengerId: null,
  });

  const [errors, setErrors] = useState({});

  // 🔹 Restore session
  useEffect(() => {
    const fromPayment = sessionStorage.getItem("fromPayment");

    if (fromPayment === "true") {
      const saved = sessionStorage.getItem("rentalPageData");

      if (saved) {
        const parsed = JSON.parse(saved);
        setUserDetails(parsed.userDetails || {});
        setDropDateTime(parsed.dropDateTime || "");
        setBookingType(parsed.bookingType || "self");
      }

      sessionStorage.removeItem("fromPayment");
    } else {
      sessionStorage.removeItem("rentalPageData");
    }
  }, []);

  // 🔹 fallback
  if (!data) {
    const saved = localStorage.getItem("tripData");
    data = saved ? JSON.parse(saved) : null;
  }

  if (!data) return <h2>No Data Found</h2>;

const cycleData = data?.bicycleData || {};
  const pickup = data?.pickup;

  const handleInputChange = (field, value) => {
    setUserDetails((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (field, file) => {
    setFiles((prev) => ({ ...prev, [field]: file }));
  };

  // 🔹 VALIDATION
  const validateForm = () => {
    let newErrors = {};

    if (!userDetails.name.trim()) newErrors.name = "Name required";
    if (!userDetails.phone.trim()) newErrors.phone = "Phone required";
    if (!userDetails.email.trim()) newErrors.email = "Email required";

    if (!files.userId) newErrors.userId = "ID required";

    if (bookingType === "other") {
      if (!userDetails.passengerName.trim())
        newErrors.passengerName = "Passenger name required";
      if (!userDetails.passengerPhone.trim())
        newErrors.passengerPhone = "Passenger phone required";
      if (!files.passengerId) newErrors.passengerId = "Passenger ID required";
    }

    // ✅ FIXED DATE
     if (!dropDateTime) {
      newErrors.dropDateTime = "Drop date & time is required";
    } else {
      const pickupDate = new Date(data.date);
      const dropDate = new Date(dropDateTime);

      if (dropDate <= pickupDate) {
        newErrors.dropDateTime = "Drop time must be after pickup time";
      }
    }

    if (!userDetails.agreed) newErrors.agreed = "Accept terms";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🔹 PRICE (CHEAPER FOR BICYCLE)
  const baseFare = cycleData?.price || 200;
  const discount = 50;
  const gst = Math.round(baseFare * 0.05);
  const security = 500;

  const total = baseFare - discount + gst + security;
  const payableAmount = paymentType === "half" ? Math.round(total / 2) : total;

  const handlePayment = () => {
    if (!validateForm()) return;

    const finalData = {
      ...data,
      userDetails,
      dropDateTime,
      bookingType,
      total,
      paymentType,
      payableAmount,
      vehicle: "bicycle",
    };

    navigate("/payment-page", {
      state: finalData,
    });
  };

  return (
    <div className="rental-details-container">
      <p className="back-link" onClick={() => navigate(-1)}>
        ← Back
      </p>

      {/* 🔹 TOP */}
      <div className="bike-top-section">
        <div className="bike-upper-section">
          <div className="image-grid">
            <img src={cycleData?.image} className="main-img" alt="cycle" />

            <div className="side-images">
              <img src={cycleData?.image} alt="" />
              <img src={cycleData?.image} alt="" />
              <img src={cycleData?.image} alt="" />
              <img src={cycleData?.image} alt="" />
            </div>
          </div>
        </div>

        <div className="bike-lower-section">
          <div className="left-section">
            <h1>{cycleData?.name}</h1>
            <p>Gear • Eco Ride • 1 Rider • ★ 4.6</p>
          </div>

          <div className="right-section">
            <h3>{pickup}</h3>
            <p className="edit-location" onClick={() => navigate("/")}>
              Edit Location
            </p>
          </div>
        </div>
      </div>

      <div className="bike-bottom-section">
        {/* LEFT */}
        <div className="bike-bottom-left-section">
          <div className="features-section">
            <h2>Bicycle Features</h2>

            <div
              className={`features-grid ${showAllFeatures ? "three-col" : "two-col"}`}
            >
              {basicBicycleFeatures.map((item, index) => (
                <div key={index} className="feature">
                  ✅ {item}
                </div>
              ))}

              {showAllFeatures &&
                extraBicycleFeatures.map((item, index) => (
                  <div key={index} className="feature">
                    ✅ {item}
                  </div>
                ))}
            </div>
          </div>
          <p
            className="view-more"
            onClick={() => setShowAllFeatures(!showAllFeatures)}
          >
            {showAllFeatures ? "Show Less" : "View More Features"}
          </p>

          <div className="policy-section">
            <h2>Rental Policy</h2>

            <div className="bike-policy-row">
              <span className="inclusion">● Inclusion: Fuel (100km)</span>
              <span className="exclusion">● Exclusion: Toll/Parking</span>
            </div>

            <button
              className="rental-policy-btn"
              onClick={() => setShowPolicy(true)}
            >
              Read Full Policy
            </button>
          </div>
      
        </div>

        {/* RIGHT FORM */}
        <div className="bike-bottom-right-section">
          <h1 className="title">Complete Your Booking</h1>

          {/* YOUR DETAILS (ALWAYS VISIBLE) */}
          <div className="input-row">
            <input
              type="text"
              placeholder="Your Full Name"
              value={userDetails.name}
              onChange={(e) => {
                const value = e.target.value;

                // allow only letters + space
                if (/^[A-Za-z\s]*$/.test(value)) {
                  handleInputChange("name", value);
                }
              }}
            />
            {errors.name && <p className="error">{errors.name}</p>}
            <input
              type="text"
              placeholder="Your Phone Number"
              value={userDetails.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
          <div className="input-row">
            <input
              type="email"
              placeholder="Your Email"
              value={userDetails.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>
          <div className="file-section">
            <p>Your Govt ID (Both Sides)</p>
            <input
              type="file"
              onChange={(e) => handleFileChange("userId", e.target.files[0])}
            />
            {errors.userId && <p className="error">{errors.userId}</p>}
          </div>

          {/* TRAVEL DROPDOWN */}
          <div className="travel-box">
            <select
              value={bookingType}
              onChange={(e) => setBookingType(e.target.value)}
            >
              <option value="self">I am travelling myself</option>
              <option value="other">I am booking for someone</option>
            </select>
          </div>

          {/* PASSENGER DETAILS (SHOW ONLY IF "OTHER") */}
          {bookingType === "other" && (
            <div className="passenger-details">
              <h3 style={{ marginTop: "15px" }}>Passenger Details</h3>

              <div className="input-row">
                <input
                  type="text"
                  placeholder="Passenger Full Name"
                  value={userDetails.passengerName}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only letters + space
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleInputChange("passengerName", value);
                    }
                  }}
                />
                {errors.passengerName && (
                  <p className="error">{errors.passengerName}</p>
                )}
                <input
                  type="text"
                  placeholder="Passenger Phone Number"
                  value={userDetails.passengerPhone}
                  onChange={(e) =>
                    handleInputChange("passengerPhone", e.target.value)
                  }
                />
                {errors.passengerPhone && (
                  <p className="error">{errors.passengerPhone}</p>
                )}
              </div>

              <div className="file-section">
                <p>Passenger Govt ID (For Verification)</p>
                <input
                  type="file"
                  onChange={(e) =>
                    handleFileChange("passengerId", e.target.files[0])
                  }
                />
                {errors.passengerId && (
                  <p className="error">{errors.passengerId}</p>
                )}
              </div>
            </div>
          )}

          {/* DATE TIME */}
          <div className="date-row">
            <div className="date-box">
              <p>PICKUP DATE/TIME</p>
              <h4>
                {data.date} | {data.time}
              </h4>
            </div>

            <div className="date-box">
              <p>DROP DATE & TIME</p>
              <input
                type="datetime-local"
                value={dropDateTime}
                onChange={(e) => setDropDateTime(e.target.value)}
              />
              {errors.dropDateTime && (
                <p className="error">{errors.dropDateTime}</p>
              )}
            </div>
          </div>

          {/* PRICE */}
          <div className="price-box">
            <h2>Price Breakdown</h2>

            <div className="price-row">
              <span>Base Fare</span>
              <span>₹{baseFare}</span>
            </div>

            <div className="price-row discount">
              <span>Discount</span>
              <span>-₹{discount}</span>
            </div>

            <div className="price-row">
              <span>GST (18%)</span>
              <span>₹{gst}</span>
            </div>

            <div className="price-row security">
              <span>Security (Refundable)</span>
              <span>₹{security}</span>
            </div>

            <hr />

            <div className="total-row">
              <span>Total Payable</span>
              <span>₹{total}</span>
            </div>
          </div>
         
          <div className="payable-box">
            <h3>Pay Now: ₹{payableAmount}</h3>
          </div>
          {/* CHECKBOX */}
          <div className="checkbox">
            <input
              type="checkbox"
              checked={userDetails.agreed}
              onChange={(e) => handleInputChange("agreed", e.target.checked)}
            />
            {errors.agreed && <p className="error">{errors.agreed}</p>}
            <label>Send me ZikRme deals & updates.</label>
          </div>

          <p className="terms">
            By clicking "Book Now", you agree to our terms. This booking is
            managed directly by <b>ZikRme team</b>.
          </p>

          <button className="pay-btn" onClick={handlePayment}>
            CONTINUE TO PAYMENT
          </button>
        </div>
      </div>

      {showPolicy && (
        <div className="rental-modal-overlay">
          <div className="rental-modal">
            <span className="close" onClick={() => setShowPolicy(false)}>
              ✖
            </span>
            <h2>Rental Policy</h2>
            <ul>
              <li>Full refund if canceled 24h before.</li>
              <li>No smoking inside car</li>
              <li> Late return: ₹500/hour</li>
              <li>Fuel to be refilled to same level</li>
              <li>✔ Fuel included for 100km</li>
              <li>✔ 24/7 Roadside Assistance</li>
              <li>✖ Toll & Parking extra</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default BicycleRentalDetailPage;
